function formFunctions() {
  var $form = $('#' + globalVar.curSlide + ' form');
  var hasSubmit = !!$form.find('input[type=submit]').length;
  $form.addClass('form-style');
  $form.trigger('reset');

  if (!hasSubmit) {
    $form.append('<input type="submit"/>');
  }
  checkboxFunctionality();
  $form.on('submit.req-form', function(e) {
    e.preventDefault();
  });

  var inputs = $form.find('input');
  inputs.keyup(function() {
    var $this = $(this);
    var characters = $this.val().length;
    var maxLength = $this.attr('maxLength');
    var lastInput = $this.next().hasClass('checkbox');

    if (characters == maxLength && !lastInput) {
      $this.next().focus();
    }
  });
  inputs.keydown(function(e) {
    if ((e.which == 8 || e.which == 46) && $(this).val() == '') {
      $(this)
        .prev('input')
        .focus();
    }
  });

  function checkboxFunctionality() {
    var fields = slides[globalVar.curSlide].form.fields;
    for (var key in fields) {
      if (fields[key].checkbox === true) {
        var checkboxes = $('#' + globalVar.curSlide + ' .' + fields[key].class);
        checkboxes.addClass('checkbox');
        checkboxes.data('key', key);
        checkboxes.each(function(idx, checkbox) {
          $(checkbox).off('click.checkbox');
          $(checkbox).on('click.checkbox', function() {
            var field =
              slides[globalVar.curSlide].form.fields[$(checkbox).data('key')];
            var checkboxSet = $('#' + globalVar.curSlide + ' .' + field.class);
            if (this.value === 'X') {
              this.value = '';
            } else {
              checkboxSet[0].value = '';
              checkboxSet[1].value = '';
              this.value = 'X';
            }
          });
        });
      }
    }
  }
}

function checkForm() {
  var fields = slides[globalVar.curSlide].form.fields;
  for (var key in fields) {
    var field = fields[key];
    var result = '';
    var inputs = $('#' + globalVar.curSlide + ' .' + field.class);

    if (field.checkbox === true)
      result = inputs.filter('.' + field.answer)[0].value === 'X';
    // Class based checkbox
    // result = inputs.filter('.' + field.answer).hasClass('selected');
    else {
      var caseSensitive = fields[key].caseSensitive;
      var answer = caseSensitive ? field.answer : field.answer.toLowerCase();
      var text = '';

      inputs.each(function(i, input) {
        text += caseSensitive ? input.value : input.value.toLowerCase();
      });

      result = text === answer;
    }
    console.log(result);
    if (!result) {
      return false;
    }
  }
  return true;
}

function validForm() {
  var valid = true;
  var requiredFields = $('#' + globalVar.curSlide)
    .find('input,textarea,select')
    .filter('[required]');
  requiredFields.each(function(i, field) {
    if (field.value === '') {
      valid = false;
      $('#' + globalVar.curSlide + ' form')
        .find('input[type=submit]')
        .trigger('click');
      return false;
    }
  });
  return valid;
}

//Class based checkbox
/* 
function checkboxFunctionality() {
  var fields = slides[globalVar.curSlide].form.fields;
  for (var key in fields) {
    if (fields[key].checkbox === true) {
      var checkboxes = $('#' + globalVar.curSlide + ' .' + fields[key].class);
      checkboxes.addClass('checkbox');
      checkboxes.removeClass('selected');
      checkboxes.data('key', key);
      checkboxes.each(function(idx, checkbox) {
        $(checkbox).off('click.checkbox');
        $(checkbox).on('click.checkbox', function() {
          var field =
            slides[globalVar.curSlide].form.fields[$(checkbox).data('key')];
          var checkboxSet = $('#' + globalVar.curSlide + ' .' + field.class);
          if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
          } else {
            checkboxSet.removeClass('selected');
            $(this).addClass('selected');
          }
        });
      });
    }
  }
} */
